import { useEffect } from "react";
import { X, Youtube, Music2 } from "lucide-react";
import { usePlayer } from "@/context/PlayerContext";
import { timeAgo } from "@/lib/api";

export const VideoModal = () => {
  const { video, closeVideo } = usePlayer();

  useEffect(() => {
    if (!video) return;
    const onKey = (e) => e.key === "Escape" && closeVideo();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => { document.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
  }, [video, closeVideo]);

  if (!video) return null;
  const tiktok = video.source === "tiktok";
  const watchUrl = tiktok ? `https://www.tiktok.com/@${video.show?.tiktok_handle || "underdogpodcasts"}/video/${video.video_id}` : `https://www.youtube.com/watch?v=${video.video_id}`;
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center p-4 sm:p-8 bg-black/85 backdrop-blur-sm on-dark" onClick={closeVideo} data-testid="video-modal">
      <div className={`relative w-full ${tiktok ? "max-w-md" : "max-w-5xl"} card-surface rounded-3xl overflow-hidden shadow-2xl reveal`} onClick={(e) => e.stopPropagation()} style={{ animationDuration: ".25s" }}>
        <button onClick={closeVideo} className="absolute top-3 right-3 z-10 h-10 w-10 rounded-full bg-black/60 text-white flex items-center justify-center hover:bg-black/80" aria-label="Close video" data-testid="video-modal-close"><X size={18} /></button>
        <div className={`${tiktok ? "aspect-[9/16] max-h-[70vh] mx-auto" : "aspect-video"} bg-black`}>
          {tiktok
            ? <iframe key={video.video_id} src={`https://www.tiktok.com/embed/v2/${video.video_id}`} title={video.title} className="h-full w-full" allow="autoplay; encrypted-media; picture-in-picture" allowFullScreen data-testid="video-modal-iframe" />
            : <iframe key={video.video_id} src={`https://www.youtube.com/embed/${video.video_id}?autoplay=1&rel=0`} title={video.title} className="h-full w-full" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-testid="video-modal-iframe" />}
        </div>
        <div className="p-5 sm:p-6 flex flex-wrap items-start justify-between gap-4">
          <div className="min-w-0">
            {video.show?.name && <p className="eyebrow mb-1">{video.show.name}</p>}
            <h3 className="font-display text-lg sm:text-2xl font-bold leading-snug" data-testid="video-modal-title">{video.title}</h3>
            <p className="mt-2 font-mono text-[11px] text-slate-400">{timeAgo(video.published_at)}</p>
          </div>
          <a href={watchUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm font-semibold text-white hover:bg-white/20" data-testid="video-modal-youtube-link">{tiktok ? <><Music2 size={16} className="text-cyan-300" /> Open on TikTok</> : <><Youtube size={16} className="text-rose-500" /> Watch on YouTube</>}</a>
        </div>
      </div>
    </div>
  );
};
